import { combineReducers } from "redux";
import service from "./service";
import stops from "./stops";
import view from "./view";
import polyline from "./polyline";

export default combineReducers({ service, stops, view, polyline });
